"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ONE_TB_SIZE_LIMIT = exports.Spaces = void 0;
exports.Spaces = {
    ONE_KB: 1024,
    ONE_MB: Math.pow(1024, 2),
    ONE_GB: Math.pow(1024, 3),
    ONE_TB: Math.pow(1024, 4),
    ONE_PB: Math.pow(1024, 5),
};
exports.ONE_TB_SIZE_LIMIT = exports.Spaces.ONE_TB;
//# sourceMappingURL=constants.js.map